import { endpoints } from '@/api/endpoints';
import { loginBusinessFIResponseSchema, loginWithSessionIdResponseSchema } from '@/api/login/schema';
import type {
  AuthenticatePayload,
  AuthenticateResponse,
  LoginBusinessFIPayload,
  LoginResponse,
} from '@/api/login/types';
import { apiRequest } from '@/api/utils/api';

export const loginUK = (email: string) =>
  apiRequest<LoginResponse>({ url: endpoints.login.root, method: 'POST', data: { email } });

export const authenticate = (payload: AuthenticatePayload) =>
  apiRequest<AuthenticateResponse>({ url: endpoints.login.authenticate, method: 'POST', data: payload });

export const loginBusinessFI = (payload: LoginBusinessFIPayload) =>
  apiRequest({
    url: endpoints.login.root,
    method: 'POST',
    schema: loginBusinessFIResponseSchema,
    data: payload,
  });

export const loginWithSessionId = (sessionId: string) =>
  apiRequest({
    url: endpoints.login.sessionId(sessionId).root,
    method: 'GET',
    schema: loginWithSessionIdResponseSchema,
  });

// Lets the backend know to update the session status for cleanup purposes
export const syncSessionId = (sessionId: string) =>
  apiRequest<void>({ url: endpoints.login.sessionId(sessionId).sync, method: 'POST' });
